var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.06 5.77"}},[_c('polygon',{attrs:{"points":"5 5.77 0 0.77 0.71 0.06 5 4.35 9.35 0 10.06 0.71 5 5.77"}})])}
var staticRenderFns = []

export { render, staticRenderFns }